<template>
  <layout name="LayoutDefault">
    <div class="Contact">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row">
            <div class="contact-form col-lg-6">
              <div v-if="validationErrors">
                <ul class="alert alert-danger" style="list-style: none;">
                  <li
                    v-for="(value, key, index) in validationErrors"
                    v-bind:key="index"
                  >
                    {{ value[0] }}
                  </li>
                </ul>
              </div>

              <form id="contact" @submit="checkForm" action="#" method="post" ref="myForm">

                <div v-if="errors.length" class="alert alert-warning">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li v-for="(error, index) in errors" v-bind:key="index">
                      {{ error[0] }}
                    </li>
                  </ul>
                </div>

                <div class="form-group">
                  <label for="exampleInputName"
                    >{{ nameType }} নাম<span class="required">*</span></label
                  >
                  <input
                    autocomplete="off"
                    type="text"
                    class="form-control"
                    id="exampleInputName"
                    name="name"
                    v-model="formData.name"
                    :placeholder="` আপনার ${nameType ? nameType : ''}নাম লিখুন`"
                  />
                </div>

                <div class="form-group">
                  <label for="exampleInputPhone"
                    >মোবাইল নাম্বার<span class="required">*</span></label
                  >
                  <input
                    autocomplete="off"
                    type="number"
                    class="form-control"
                    name="phone"
                    id="exampleInputPhone"
                    v-model="formData.mobile"
                    placeholder=" আপনার মোবাইল নাম্বার এখানে দিন"
                  />
                </div>

                <div class="form-group">
                  <label for="exampleInputMessage"
                    >ফাইল<span class="required">*</span></label
                  >
                  <div>
                    <input type="file"  @change="onFileChange" />
                    <div class="required">Allowed Format: .jpg, .jpeg, .png, Max Size: 4MB</div>
                  </div>
                </div>

                <button type="submit" class="btn btn-primary" :disabled="isDisabled">
                  সাবমিট
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";

export default {
  name: `Home`,
  components: {
    Layout
  },
  data() {
    return {
      errors: [],
      isDisabled: false,
      validationErrors: null,
      nameType: "",
      formData: {
        name: null,
        email: null,
        mobile: null,
        password: null,
        redirectUrl: null,
        file: ""
      }
    };
  },
  methods: {
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      const fileSizeInBytes = files[0].size;
      const fileSizeInKB = Math.round(fileSizeInBytes / 1024) / 1024;
      if (fileSizeInKB > 4) {
        this.flashMessage.error({ message: "Max file size 4MB allowed" });
      }
      if (!files.length) return;
      this.formData.file = files[0];
    },
    checkForm: async function(e) {
      e.preventDefault();

      if (!this.formData.name) {
        this.flashMessage.error({ message: "আপনার নাম লিখুন" });
        return false;
      }

      if (!this.formData.mobile || this.formData.mobile.length != 11) {
        this.flashMessage.error({ message: "আপনার মোবাইল নাম্বার লিখুন" });
        return false;
      }

      if (!this.formData.file) {
        this.flashMessage.error({ message: "ফাইল সিলেক্ট করুন" });
        return false;
      }

      let caData = new FormData();
      caData.append("file", this.formData.file);
      caData.append("name", this.formData.name);
      caData.append("mobile", this.formData.mobile);

      this.isDisabled = true;
      try {
        const response = await this.$http.post("ca-quiz", caData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (response.data.status) {
          this.flashMessage.success({ message: response.data.message });
          this.$refs.myForm.reset();
        } else {
          this.isDisabled = false;
          this.flashMessage.error({ message: response.data.message });
        }
      } catch (error) {
        this.isDisabled = false;
        console.error(error);
        this.flashMessage.error({ message: "Something went wrong. Please try again later." });
      }
    }
  }
};
</script>
